import { gql } from "@apollo/client";

export const GET_SIGNATURE = gql`
query EmailSignature {
  emailSignature {
    signature
    userId
  }
}
`